import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/(app)/productivity/chats/')({
  component: ChatsIndex,
});

function ChatsIndex() {
  return (
    <Card className="h-[85vh]">
      <CardHeader>
        <CardTitle>Chats</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-sm text-muted-foreground">
          No conversations yet. Start a new chat from the employee profile.
        </div>
      </CardContent>
    </Card>
  );
}